import LoginForm from '@/components/elements/frontPage/LoginForm';

export default function FrontPage() {
  return (
	<div className='container_main_bg'>
		<div className='container'>
			<div className='row'>
				<LoginForm/>
			</div>
		</div>
	</div>
    );
}
